module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step1_Image27.341e13c1.jpg";